import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { fetchAssetsThunk } from "./thunk";
import { AssetsState, PlatformAssets } from "Vendor/Utils/StudioTypes";

const initialState: AssetsState = {
  fonts: [],
  colors: [],
  loading: false,
  error: null,
};

const assetsSlice = createSlice({
    name: 'assets',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
        .addCase(fetchAssetsThunk.pending, (state) => {
            state.loading = true;
            state.error = null;
        })
        .addCase(fetchAssetsThunk.fulfilled, (state, action: PayloadAction<PlatformAssets>) => {
            state.fonts = action.payload.fonts;
            state.colors = action.payload.colors;
            state.loading = false;
        })
        .addCase(fetchAssetsThunk.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload as string;
        });
    },
});

export default assetsSlice.reducer;
